module.exports = __webpack_public_path__ + "media/assets/images/sunny-c0c8fcf0c7c1cdcdce82d412bbdb71da.png";